import { Grid, Tab, Tabs } from '@mui/material';
import { GetPFRCodeTableRow } from '../../../services/apiTypes';
import React, { useState } from 'react';
import BeforeTable from './PFRCodeTable/BeforeTable';
import AfterTable from './PFRCodeTable/AfterTable';
import { useTranslation } from 'react-i18next';

type PFRCodeTableProps = {
  pfrCodeList: {
    before: GetPFRCodeTableRow[];
    after: GetPFRCodeTableRow[];
  };
  isReported: boolean;
  setIsReported: React.Dispatch<React.SetStateAction<boolean>>;
};

const PFRCodeTable: React.FC<PFRCodeTableProps> = ({
  pfrCodeList,
  isReported,
  setIsReported,
}) => {
  const { t } = useTranslation();
  const [isConversionAssy, setIsConversionAssy] = useState(false);
  const [tabValue, setTabValue] = useState(1);
  const [beforeConversionAfter, setBeforeConversionAfter] = useState<
    GetPFRCodeTableRow[]
  >([]);

  const handleChange = (_: React.SyntheticEvent, newValue: any) => {
    setTabValue(newValue);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        backgroundColor: '#F2F2F2',
        margin: '20px',
      }}
    >
      <Grid size={12}>
        <Grid
          container
          spacing={1}
          sx={{
            margin: '0px',
            padding: '20px',
          }}
        >
          <Grid size={12}>
            {pfrCodeList.before.length === 0 ? (
              <AfterTable
                pfrCodeList={pfrCodeList}
                isConversionAssy={isConversionAssy}
                setIsConversionAssy={setIsConversionAssy}
                beforeConversionAfter={beforeConversionAfter}
                setBeforeConversionAfter={setBeforeConversionAfter}
                isReported={isReported}
                setIsReported={setIsReported}
              />
            ) : (
              <React.Fragment>
                <Tabs
                  sx={{
                    borderBottom: 0,
                    borderColor: '#F2F2F2',
                  }}
                  onChange={handleChange}
                  value={tabValue}
                >
                  <Tab label={t('LBL_BEFORE')} />
                  <Tab label={t('LBL_AFTER')} />
                </Tabs>
                {tabValue === 0 ? (
                  <BeforeTable pfrCodeList={pfrCodeList}></BeforeTable>
                ) : (
                  <AfterTable
                    pfrCodeList={pfrCodeList}
                    isConversionAssy={isConversionAssy}
                    setIsConversionAssy={setIsConversionAssy}
                    beforeConversionAfter={beforeConversionAfter}
                    setBeforeConversionAfter={setBeforeConversionAfter}
                    isReported={isReported}
                    setIsReported={setIsReported}
                  />
                )}
              </React.Fragment>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PFRCodeTable;
